let cW = 400
let cH = 300

module.exports = {    
    CellRef:[
        {
            no:0,
            width:cW*2,
            height:cH,
            top:0,
            left:400
        },
        {
            no:1,
            width:cW,
            height:cH,
            top:cH,
            left:400
        },
        {
            no:2,
            width:cW,
            height:cH,
            top:cH,
            left:400+cW
        },
        {
            no:3,
            width:cW,
            height:cH,
            top:0,
            left:400+cW*2
        },
        {
            no:4,
            width:cW,
            height:cH,
            top:cH,
            left:400+cW*2
        },
        {
            no:5,
            width:cW,
            height:cH*2,
            top:0,
            left:400+cW*3
        }
    ]
}